var qcal = null; // Make the kiosk available to the browser for debugging

$( function () {
	setTimeout( function () {
		qcal = new QCalViewModel();
		ko.applyBindings( qcal );
		qcal.init();
	}, 200 );
});
